import _typeof from "@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["auto", "imageAltPrefix", "listPosition", "page", "placement", "productTitleAs", "productTypes", "showArrowControls", "showControls", "showDiscount", "showDiscountOnlyCashInfo", "showInCashInfo", "showPartialNextSlide", "slidesPerView", "title", "titleAs", "types", "widgets"];
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { oneOfType, arrayOf, bool, shape, string } from 'prop-types';
import Heading from '@magalu/stereo-ui/atoms/Heading';
import Grid from '@magalu/stereo-ui/atoms/Grid';
import ProductCarousel from '@magalu/stereo-ui/organisms/ProductCarousel';
import { usePublisher } from '@magalu/mixer-publisher';
import { slug } from '@magalu/mixer-utils';
import withLayoutProps from '../../../hocs/withLayoutProps';
import usePercycle from './hook/usePercycle';
import buildCustomParams from './hook/buildCustomParams';
import { Container, PixelContainer } from './PercycleProductCarousel.styles';
var PercycleProductCarousel = function PercycleProductCarousel(_ref) {
  var _product$category, _product$subcategory, _structure$cookies, _structure$cookies$ac, _structure$route2, _structure$route3;
  var staticProps = _ref["static"],
    structure = _ref.structure,
    data = _ref.data;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var product = data.product;
  var _structure$route = structure.route,
    _structure$route$prod = _structure$route.productId,
    productId = _structure$route$prod === void 0 ? '' : _structure$route$prod,
    _structure$route$cate = _structure$route.categorySlug,
    categorySlug = _structure$route$cate === void 0 ? slug(product == null ? void 0 : (_product$category = product.category) == null ? void 0 : _product$category.name) : _structure$route$cate,
    _structure$route$subC = _structure$route.subCategorySlug,
    subCategorySlug = _structure$route$subC === void 0 ? slug(product == null ? void 0 : (_product$subcategory = product.subcategory) == null ? void 0 : _product$subcategory.name) : _structure$route$subC;
  var _staticProps$auto = staticProps.auto,
    auto = _staticProps$auto === void 0 ? true : _staticProps$auto,
    _staticProps$imageAlt = staticProps.imageAltPrefix,
    imageAltPrefix = _staticProps$imageAlt === void 0 ? 'Imagem de ' : _staticProps$imageAlt,
    _staticProps$listPosi = staticProps.listPosition,
    listPosition = _staticProps$listPosi === void 0 ? 1 : _staticProps$listPosi,
    page = staticProps.page,
    placement = staticProps.placement,
    _staticProps$productT = staticProps.productTitleAs,
    productTitleAs = _staticProps$productT === void 0 ? 'h3' : _staticProps$productT,
    _staticProps$productT2 = staticProps.productTypes,
    productTypes = _staticProps$productT2 === void 0 ? 'all' : _staticProps$productT2,
    _staticProps$showArro = staticProps.showArrowControls,
    showArrowControls = _staticProps$showArro === void 0 ? false : _staticProps$showArro,
    _staticProps$showCont = staticProps.showControls,
    showControls = _staticProps$showCont === void 0 ? true : _staticProps$showCont,
    _staticProps$showDisc = staticProps.showDiscount,
    showDiscount = _staticProps$showDisc === void 0 ? false : _staticProps$showDisc,
    _staticProps$showDisc2 = staticProps.showDiscountOnlyCashInfo,
    showDiscountOnlyCashInfo = _staticProps$showDisc2 === void 0 ? false : _staticProps$showDisc2,
    _staticProps$showInCa = staticProps.showInCashInfo,
    showInCashInfo = _staticProps$showInCa === void 0 ? false : _staticProps$showInCa,
    _staticProps$showPart = staticProps.showPartialNextSlide,
    showPartialNextSlide = _staticProps$showPart === void 0 ? true : _staticProps$showPart,
    _staticProps$slidesPe = staticProps.slidesPerView,
    slidesPerView = _staticProps$slidesPe === void 0 ? 3 : _staticProps$slidesPe,
    title = staticProps.title,
    _staticProps$titleAs = staticProps.titleAs,
    titleAs = _staticProps$titleAs === void 0 ? 'h2' : _staticProps$titleAs,
    _staticProps$types = staticProps.types,
    types = _staticProps$types === void 0 ? 'native' : _staticProps$types,
    _staticProps$widgets = staticProps.widgets,
    widgetsParam = _staticProps$widgets === void 0 ? ['native', '24_all'] : _staticProps$widgets,
    props = _objectWithoutProperties(staticProps, _excluded);
  var categories = [categorySlug, subCategorySlug].filter(Boolean).join(' > ');
  var showcase = {
    pageId: page,
    placeId: placement,
    title: title,
    type: 'carousel'
  };
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    activeItems = _useState2[0],
    setActiveItems = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    widgets = _useState4[0],
    setWidgets = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    viewedPixel = _useState6[0],
    setViewedPixel = _useState6[1];
  var eventData = {
    customer_id: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id,
    display: 'galeria',
    filters: structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.filters,
    list: title,
    listPosition: listPosition,
    origin: 'percycle',
    pageName: structure == null ? void 0 : structure.name,
    showcase: showcase,
    term: structure == null ? void 0 : (_structure$route3 = structure.route) == null ? void 0 : _structure$route3.term,
    type: 'recomendacao'
  };
  var handleProductClick = useCallback(function (_e, clickedProduct) {
    var _structure$route4;
    publish('productlist:selectItem:click', _extends({}, eventData, clickedProduct));
    publish('productlist:click', _extends({}, clickedProduct, {
      display: 'galeria',
      filters: structure == null ? void 0 : (_structure$route4 = structure.route) == null ? void 0 : _structure$route4.filters,
      list: title,
      listPosition: listPosition,
      origin: 'percycle',
      showcase: showcase,
      type: 'recomendacao'
    }));
  }, [title, listPosition, showcase]);
  var getPercycleWidgets = useCallback(_asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    var percycleParams, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          percycleParams = _extends({
            categories: categories,
            customPlacements: page,
            id: productId,
            placement: placement,
            productTypes: productTypes,
            types: types,
            widgets: widgetsParam
          }, buildCustomParams({
            data: data,
            structure: structure,
            type: structure.route.id
          }));
          _context.next = 3;
          return usePercycle(percycleParams);
        case 3:
          response = _context.sent;
          setWidgets(Array.isArray(response) ? response : []);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [placement, page, categories, productId]);
  var updatePercycleViewedWidget = useCallback(function () {
    var activeProductPixel = activeItems.map(function (item) {
      return item == null ? void 0 : item.px;
    });
    var pixels = [].concat(_toConsumableArray(widgets == null ? void 0 : widgets.map(function (_ref3) {
      var px = _ref3.px;
      return px;
    })), _toConsumableArray(activeProductPixel)).filter(Boolean);
    var uniqueViewed = new Set([].concat(_toConsumableArray(viewedPixel), _toConsumableArray(pixels)));
    setViewedPixel(_toConsumableArray(uniqueViewed));
  }, [activeItems]);
  useEffect(function () {
    getPercycleWidgets();
    return function () {
      setWidgets([]);
    };
  }, []);
  useLayoutEffect(function () {
    updatePercycleViewedWidget();
    return function () {
      setViewedPixel([]);
    };
  }, [activeItems]);
  useEffect(function () {
    if (widgets) {
      widgets.forEach(function (widget, index) {
        var _widget$data;
        if (widget == null ? void 0 : (_widget$data = widget.data) == null ? void 0 : _widget$data.length) {
          var _structure$route5;
          publish('productlist:impression', {
            display: 'gallery',
            filters: structure == null ? void 0 : (_structure$route5 = structure.route) == null ? void 0 : _structure$route5.filters,
            list: title,
            listPosition: listPosition + index,
            origin: 'percycle',
            products: widget.data,
            showcase: showcase,
            type: 'recomendacao'
          });
        }
      });
    }
  }, [widgets]);
  var handleProductView = function handleProductView(productData, index) {
    var _structure$route6;
    publish('product:view', {
      display: 'gallery',
      filters: structure == null ? void 0 : (_structure$route6 = structure.route) == null ? void 0 : _structure$route6.filters,
      list: title,
      listPosition: listPosition + index,
      origin: 'percycle',
      product: _extends({}, productData, {
        position: productData.index + 1
      }),
      type: 'recomendacao'
    });
    publish('product:viewItemList', _extends({}, eventData, productData));
  };
  return React.createElement(React.Fragment, null, (widgets == null ? void 0 : widgets.some(function (widget) {
    var _widget$data2;
    return !!(widget == null ? void 0 : (_widget$data2 = widget.data) == null ? void 0 : _widget$data2.length);
  })) && React.createElement(Container, _extends({
    "data-testid": "percycle-container",
    m: "20px 0 25px"
  }, props), React.createElement(Heading, {
    "data-testid": "percycle-title",
    color: "base",
    as: titleAs,
    fontSize: [2, 4, 5, 5],
    fontWeight: "medium",
    lineHeight: "display",
    m: "0 8px 12px"
  }, title), widgets.map(function (widget, index) {
    var _widget$data3;
    return !!(widget == null ? void 0 : (_widget$data3 = widget.data) == null ? void 0 : _widget$data3.length) && React.createElement(Grid, {
      maxWidth: "100%",
      mb: 4
    }, React.createElement(ProductCarousel, {
      gutter: 8,
      onChange: setActiveItems,
      onProductView: function onProductView(productData) {
        return handleProductView(productData, index);
      },
      onClick: handleProductClick,
      products: widget.data,
      productTitleAs: productTitleAs,
      imageAltPrefix: imageAltPrefix,
      auto: auto,
      showRating: false,
      showArrowControls: showArrowControls,
      showControls: showControls,
      slidesPerView: slidesPerView,
      showInCashInfo: showInCashInfo,
      showPartialNextSlide: showPartialNextSlide,
      showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
      showDiscount: showDiscount
    }));
  })), !!viewedPixel.length && React.createElement(PixelContainer, {
    "data-testid": "percycle-px"
  }, viewedPixel.map(function (px) {
    return React.createElement("img", {
      "data-testid": "percycle-px-img",
      key: px,
      src: px,
      alt: "native-pixel-home"
    });
  })));
};
PercycleProductCarousel.ssr = false;
PercycleProductCarousel.defaultProps = {
  "static": {}
};
process.env.NODE_ENV !== "production" ? PercycleProductCarousel.propTypes = {
  data: shape({}).isRequired,
  "static": shape({
    auto: bool,
    categories: arrayOf(string),
    imageAltPrefix: string,
    page: oneOfType([arrayOf(string), string]).isRequired,
    placement: string.isRequired,
    productTitleAs: string,
    title: string.isRequired,
    titleAs: string
  }),
  structure: shape({
    cookies: shape({}),
    route: shape({})
  }).isRequired
} : void 0;
export default withLayoutProps(PercycleProductCarousel);